import { useEffect, useState } from 'react';

/**
 * Returns `value` delayed by `delayMs`, collapsing rapid changes (e.g. search
 * keystrokes) into a single settled value. The latest value always wins — a change
 * before the delay elapses cancels the pending update.
 *
 * The standard debounce for the app's search inputs (Access Control, Organizations,
 * Deliveries, Raw Footage): pair it with a local `query` `useState`.
 */
export function useDebouncedValue<T>(value: T, delayMs: number): T {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const id = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(id);
  }, [value, delayMs]);

  return debounced;
}
